<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-23 09:04:23
 * @LastEditTime : 2025-12-12 10:00:22
 * @LastEditors  : yangxr
 * @Description  : 协外合同
 * @FilePath     : \icps_fb\src\views\platform\ICPS\GHnumber\components\sourcingout.vue
-->
<template>
  <div class="table outsourcing">
    <div class="card">
      <div class="card_nav">
        <div>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), reset()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small" class="bottom_three" @click="UpdateOrDelete('update_enable', 1)">
            <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
            启用
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small" class="bottom_four" @click="UpdateOrDelete('update_enable', 0)">
            <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
            禁用
          </el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'TIAOJIA')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="riseInPriceQueryOneByidFun(yiFenPeiRadio)">调价</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'KAIHUXINXI')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="queryListsByPidFun(yiFenPeiRadio)">开户信息</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'FENPEIZHANGHAO')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="open(yiFenPeiRadio, 'dialog1')">分配账号</el-button>
        </div>
        <div>
          <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
            <el-link :underline="false">
              <span class="el-icon--left">
                <i class="iconfont iconicon_button_filtrate"></i>
              </span>
              筛选
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in table" :key="index">
                <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCHU') !== -1" :underline="false" @click="load()">
            <span class="el-icon--left">
              <i class="iconfont iconicon_button_export1"></i>
            </span>
            导出
          </el-link>
        </div>
      </div>
      <div v-loading="tableLoading" class="card_info">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
            <template slot-scope="scope">
              <el-radio v-model="yiFenPeiRadio" :label="scope.row">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <template v-for="(item, index2) in table">
            <el-table-column v-if="item.label == '操作'" :key="index2" fixed="right" :label="item.label" align="center" :width="item.width">
              <template slot-scope="scope">
                <el-dropdown :hide-on-click="false" trigger="click">
                  <el-button size="mini" class="bottom_one">更多</el-button>
                  <el-dropdown-menu slot="dropdown" style="text-align: left">
                    <el-dropdown-item v-if="ButtonList.some(res => res.buttonValue == 'XIUGAI')">
                      <el-button style="margin: 5px 0" class="bottom_one" size="mini" @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '修改'), (modifyType = false)"> 修改 </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button size="mini" style="margin: 5px 0" class="bottom_one" @click="$refs.ModifyTheRecord.contractQueryPageContractLogFun(scope.row.id)">更改记录</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
              <template slot-scope="scope">
                <div v-if="item.label == '状态'">
                  <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                  <span v-else-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                </div>
                <el-link v-else-if="item.label == '合同ID'" class="table_link" :underline="false" @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '查看')">{{ scope.row.code }}</el-link>
                <div v-else-if="item.label == '站点名称'">
                  <span>{{ scope.row.stations | stationsFun }}</span>
                </div>
                <div v-else-if="item.label == '合同类型'">
                  <span v-if="scope.row.contractContractType == 1">购销</span>
                  <span v-if="scope.row.contractContractType == 2">代加工</span>
                </div>
                <div v-else-if="item.label == '合同签订情况'">
                  <span v-if="scope.row.concludeAndSignStatus == 1">已签订</span>
                  <span v-else>未签订</span>
                </div>
                <div v-else-if="item.label == '华西云采注册情况'">
                  <span v-if="scope.row.loginStatus == 1">已注册</span>
                  <span v-else>未注册</span>
                </div>
                <div v-else-if="item.label == '合同有效期'">{{ scope.row.startDay + " - " + scope.row.endDay }}</div>
                <!-- <span v-else-if="item.label == '合同有效期'" style="color: #969799">{{ scope.row.contractBeginTime }} -- {{ scope.row.contractEndTime }}</span> -->
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData(), (yiFenPeiRadio = '')"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </div>
    <!-- 添加·合同 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="1110px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo FZYform scroll" style="height: calc(85vh - 230px); padding-right: 5px; overflow: auto">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="110px">
          <div class="form-title">基本信息</div>
          <el-form-item prop="contractContractType">
            <span slot="label">合同类型</span>
            <el-select v-model="formDate.contractContractType" placeholder="请选择" :disabled="modifyType" @change="formDate.splitMode = ''">
              <el-option label="购销" :value="1"></el-option>
              <el-option label="代加工" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDate.contractContractType == 1" prop="splitMode">
            <span slot="label">拆分方式</span>
            <el-select v-model="formDate.splitMode" placeholder="请选择" :disabled="modifyType">
              <el-option label="砼购销" :value="1"></el-option>
              <el-option label="砂浆购销" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDate.contractContractType == 2" prop="splitMode">
            <span slot="label">拆分方式</span>
            <el-select v-model="formDate.splitMode" placeholder="请选择" :disabled="modifyType">
              <el-option label="理论配合比" :value="1"></el-option>
              <el-option label="实际配合比" :value="2"></el-option>
              <el-option label="原材料抵扣" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDate.contractContractType != '3'"> </el-form-item>
          <el-form-item prop="firstPartyId">
            <span slot="label">权限公司</span>
            <el-select
              ref="selection1"
              v-model="formDate.firstPartyId"
              placeholder="请选择"
              :disabled="modifyType"
              @change="
                $nextTick(() => {
                  formDate.firstParty = $refs.selection1.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in companylist" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractSigningSubjectId">
            <span slot="label">合同签订主体</span>
            <el-select
              ref="selection1"
              v-model="formDate.contractSigningSubjectId"
              placeholder="请选择"
              :disabled="modifyType"
              @change="
                $nextTick(() => {
                  formDate.contractSigningSubject = $refs.selection1.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item prop="stationsList" :rules="[{ required: true, message: '请选择站点', trigger: 'change' }]">
            <span slot="label">站点名称</span>
            <el-select v-model="formDate.stationsList" placeholder="请选择" multiple :disabled="modifyType" @change="stationsTypeFun()" @remove-tag="stationsTypeFun()">
              <el-option v-for="(item, index) in sitelist" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item prop="supplierId">
            <span slot="label">主合同单位</span>
            <el-select v-model="formDate.supplierId" filterable placeholder="请选择" :disabled="modifyType" @change="changemainCompanyId(formDate.supplierId)">
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">供应商类别</span>
            <div style="width: 340px">{{ formDate.supplierType }}</div>
          </el-form-item>
          <el-form-item prop="contractNumber">
            <span slot="label">合同编号</span>
            <el-input v-model="formDate.contractNumber" placeholder="请输入" clearable :disabled="modifyType" @blur="queryContractNumberFun()"></el-input>
          </el-form-item>
          <el-form-item prop="callForBidsNumber">
            <span slot="label">招标编号</span>
            <el-input v-model="formDate.callForBidsNumber" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="concludeAndSignStatus">
            <span slot="label">合同签订情况</span>
            <el-select v-model="formDate.concludeAndSignStatus" placeholder="请选择" :disabled="modifyType">
              <el-option label="已签订" :value="1"></el-option>
              <el-option label="未签订" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="loginStatus" label-width="140px">
            <span slot="label">华西云采注册情况</span>
            <el-select v-model="formDate.loginStatus" placeholder="请选择" class="hyyc" :disabled="modifyType">
              <el-option label="已注册" :value="1"></el-option>
              <el-option label="未注册" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="linkman">
            <span slot="label">联系人</span>
            <el-input v-model="formDate.linkman" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <span slot="label">联系电话</span>
            <el-input v-model="formDate.phone" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="startDayendDay">
            <span slot="label">合同有效期</span>
            <el-date-picker
              v-model="formDate.startDayendDay"
              unlink-panels
              style="width: 340px"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="modifyType"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="taxRate">
            <span slot="label">税率</span>
            <el-select v-model="formDate.taxRate" placeholder="请选择" style="width: 340px" :disabled="modifyType">
              <el-option v-for="(item, index) in taxRateList" :key="index" :label="item.itemName" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <div class="form-title">单价</div>
          <el-form-item prop="processingPrice" label-width="140px">
            <span slot="label" style="position: relative; top: 6px">加工价（含税）</span>
            <el-input v-model="formDate.processingPrice" type="Number" placeholder="请输入" clearable :disabled="modifyType" style="width: 140px"></el-input>
            <span style="margin-left: 10px">
              元/m
              <sup>3</sup>
            </span>
          </el-form-item>
          <div class="form-title">产品信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="强度等级" prop="strengthGradeArr">
                <el-select v-model="formDate.strengthGradeArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked1" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll1">全选</el-checkbox>
                  <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性能等级" prop="performanceRequirementsArr">
                <el-select v-model="formDate.performanceRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked2" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll2">全选</el-checkbox>
                  <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="材料要求" prop="materialRequirementsArr">
                <el-select v-model="formDate.materialRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked3" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll3">全选</el-checkbox>
                  <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="特殊要求" prop="specialRequirementsArr">
                <el-select v-model="formDate.specialRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked4" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll4">全选</el-checkbox>
                  <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="其他要求" prop="otherRequirementsArr">
                <el-select v-model="formDate.otherRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked5" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll5">全选</el-checkbox>
                  <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="外加剂要求" prop="additiveRequirementsArr">
                <el-select v-model="formDate.additiveRequirementsArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked6" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll6">全选</el-checkbox>
                  <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-title">泵送信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="浇筑方式" prop="pouringMethodArr">
                <el-select v-model="formDate.pouringMethodArr" multiple placeholder="请选择" @change="$forceUpdate()">
                  <el-checkbox v-model="checked7" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll7">全选</el-checkbox>
                  <el-option v-for="item in pumpTypeList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="泵送方" prop="pumpCompensation">
                <el-radio-group v-model="formDate.pumpCompensation">
                  <el-radio :label="1">合同签订主体</el-radio>
                  <el-radio :label="2">主合同单位</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="formDate.pumpCompensation" :span="12">
              <span>若是{{ formDate.pumpCompensation == 1 ? "主合同单位" : "合同签订主体" }}泵送,则需补差价</span>
              <el-input
                v-model="formDate.pumpCompensationPrice"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              >
              </el-input>
              <span>元/方</span>
            </el-col>
          </el-row>
          <div class="form-title">运输信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="运输方" prop="transportCompensation">
                <el-radio-group v-model="formDate.transportCompensation">
                  <el-radio :label="1">合同签订主体</el-radio>
                  <el-radio :label="2">主合同单位</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="formDate.transportCompensation" :span="12">
              <span>若是{{ formDate.transportCompensation == 1 ? "主合同单位" : "合同签订主体" }}运输,则需补差价</span>
              <el-input
                v-model="formDate.transportCompensationPrice"
                v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
                style="width: 160px; margin: 0 20px"
                placeholder="请输入"
                type="Number"
              >
              </el-input>
              <span>元/方</span>
            </el-col>
          </el-row>
          <!-- <div class="FZY1-3">
            <div v-for="(v3, k3) in yunPriceArr" :key="k3">
              <div v-if="k3 == 0" class="liBox1">
                <div>
                  <span>小于</span>
                  <el-input-number v-model="v3.costName" size="mini" :controls="false" :precision="2" :disabled="modifyType" @blur="inpuSizeCheck(v3.costName, k3, yunPriceArr)"></el-input-number>
                </div>
                <div>
                  <span>千米</span>
                  <b>：</b>
                  <el-input-number v-model="v3.costUnit" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
              <div v-if="k3 > 0 && k3 != yunPriceArr.length - 1" class="liBox3">
                <div>
                  <div>
                    <el-input-number v-model="yunPriceArr[k3 - 1].costName" size="mini" :controls="false" :precision="2" disabled></el-input-number>
                    <span>至</span>
                    <el-input-number v-model="v3.costName" size="mini" :controls="false" :precision="2" :disabled="modifyType" @blur="inpuSizeCheck(v3.costName, k3, yunPriceArr)"></el-input-number>
                  </div>
                  <div>
                    <span>千米</span>
                    <b>：</b>
                    <el-input-number v-model="v3.costUnit" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
                    <span>元/方</span>
                  </div>
                </div>
                <div>
                  <el-button v-if="yunPriceArr.length - 2 == k3" class="bottom_text" :disabled="modifyType" @click="addJson()">添加区间</el-button>
                  <el-button v-else class="bottom_text" :disabled="modifyType" @click="delJson(k3)">删除区间</el-button>
                </div>
              </div>
              <div v-if="k3 == yunPriceArr.length - 1" class="liBox2" style="width: 100%">
                <div>
                  <span>大于</span>
                  <el-input-number v-model="yunPriceArr[k3 - 1].costName" size="mini" :controls="false" :precision="2" disabled></el-input-number>
                </div>
                <div>
                  <span>千米</span>
                  <b>：</b>
                  <span>每增加</span>
                  <el-input-number v-model="v3.costDetail" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
                  <span>千米，增加</span>
                  <el-input-number v-model="v3.costUnit" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
            </div>
          </div>
          <el-form-item style="margin-top: 10px">
            <span slot="label">柴油基准价</span>
            <el-input v-model="formDate.oilPrice" placeholder="请输入" clearable :disabled="modifyType"></el-input>
            <span style="margin-left: 10px">元/升</span>
          </el-form-item>
          <div class="form-title">泵送价格设置</div>
          <div>
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('泵车类型')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpPriceArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="泵车类型" align="center" width="250">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.costId" size="mini" placeholder="选择" :disabled="modifyType" style="width: 100% !important" @change="pumpTypeId_pumpTypeFun(scope.row, scope.$index, '泵车类型')">
                    <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="单价（元/方）" align="center">
                <template slot-scope="scope">
                  <el-link class="table_link" :underline="false" @click="basePriceListFun(scope.row.list, scope.$index)">设置</el-link>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '泵车类型', scope.row)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div> -->
          <div v-if="formDate.contractContractType == 2 && (formDate.splitMode == 1 || formDate.splitMode == 2)" class="form-title">{{ formDate.splitMode == 1 ? "理论配合比" : "实际配合比" }}</div>
          <div v-if="formDate.contractContractType == 2 && (formDate.splitMode == 1 || formDate.splitMode == 2)">
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('工控拆分')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="splitPriceArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="原材料" align="center" width="250">
                <template slot-scope="scope">
                  <span v-if="scope.row.rawMaterialName" class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index, scope.row.rawMaterialId)">{{ scope.row.rawMaterialName }}</span>
                  <span v-else class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun(scope.$index)">选择</span>
                </template>
              </el-table-column>
              <el-table-column label="供应商" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.supperId" class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun2(scope.$index, scope.row.supperId)">{{ scope.row.supperName }}</span>
                  <span v-else class="table_link" style="cursor: pointer" @click="ListChoiceTypeFun2(scope.$index)">选择</span>
                </template>
              </el-table-column>
              <el-table-column v-if="formDate.splitMode == 1" label="配合比" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.mixProportion" size="mini" style="width: 120px"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="单价（元/吨）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.rawPrice" size="mini" style="width: 120px"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center" width="250">
                <template slot-scope="scope">
                  <FileComponent3 fileCode="outsourcingContractFile" :files="scope.row.files" @deleteFile="deleteFile3($event, scope.row)" @uplodeSuccess="uplodeSuccess3($event, scope.row)" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '工控拆分', scope.row)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div v-if="formDate.contractContractType != 3">
            <div class="form-title">产品价格设置</div>
            <div>
              <div style="padding-bottom: 10px">
                <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('强度等级')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="goodPriceArr" tooltip-effect="dark" class="FZYselectList">
                <el-table-column label="强度等级" align="center" width="250">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.costId" size="mini" placeholder="选择" :disabled="modifyType" style="width: 100% !important" @change="pumpTypeId_pumpTypeFun(scope.row, scope.$index, '强度等级')">
                      <el-option v-for="item in goodPriceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="预计量" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.costDetail" size="mini" style="width: 100%" placeholder="请输入" :disabled="modifyType" />
                  </template>
                </el-table-column>
                <el-table-column label="单价（元/方）" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.costUnit" type="Number" size="mini" style="width: 100%" placeholder="输入价格" :disabled="modifyType" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left" prop="specification">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '强度等级')">
                      <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="form-title">附加收费项价格设置</div>
            <div>
              <div style="padding-bottom: 10px">
                <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('附加收费项')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fuPriceArr" tooltip-effect="dark" class="FZYselectList">
                <el-table-column label="附加收费项" align="center" width="250">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.costId" size="mini" placeholder="选择" :disabled="modifyType" style="width: 100% !important" @change="pumpTypeId_pumpTypeFun(scope.row, scope.$index, '附加收费项')">
                      <el-option v-for="item in fuPriceList" :key="item.ID" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="规格/类型" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.costDetail" size="mini" style="width: 100%" placeholder="请输入" :disabled="modifyType" />
                  </template>
                </el-table-column>
                <el-table-column label="单价（元/方）" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.costUnit" type="Number" size="mini" style="width: 100%" placeholder="输入价格" :disabled="modifyType" />
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="left" prop="specification">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '附加收费项')">
                      <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div> -->
          <div class="form-title">协外站点</div>
          <div>
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('协外站点')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="otherStationArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="协外站点" align="center">
                <template slot-scope="scope">
                  <el-select
                    :ref="`sourcingOutStation${scope.$index}`"
                    v-model="scope.row.id"
                    placeholder="请选择"
                    :disabled="modifyType"
                    @change="
                      sourcingOutStation(scope.row, scope.$index),
                        $nextTick(() => {
                          scope.row.name = $refs[`sourcingOutStation${scope.$index}`].selectedLabel;
                        })
                    "
                  >
                    <el-option v-for="(item, index) in sitelist" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '协外站点')">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="form-title">特殊运载</div>
          <div>
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList('特殊运载')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="specialTransport" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="浇筑方式" align="center">
                <template slot-scope="scope">
                  <el-select
                    ref="pumpId"
                    v-model="scope.row.pumpId"
                    size="mini"
                    placeholder="选择"
                    :disabled="modifyType"
                    style="width: 100% !important"
                    @change="
                      $nextTick(() => {
                        scope.row.pumpName = $refs.pumpId.selectedLabel;
                      })
                    "
                  >
                    <el-option v-for="item in noPumpList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="单价（元/方）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" type="Number" size="mini" style="width: 100%" placeholder="输入价格" :disabled="modifyType" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index, '特殊运载')">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div class="form-title">调价规则</div>
          <el-form-item prop="adjustMethod">
            <span slot="label">调价方式</span>
            <el-radio-group v-model="formDate.adjustMethod">
              <el-radio :label="1">补充协议调价</el-radio>
              <el-radio :label="2">信息价调价</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <div class="form-title">结算规则</div>
          <!-- <el-form-item prop="clearingFormId">
            <span slot="label">结算方式</span>
            <el-select v-model="formDate.clearingFormId" placeholder="请选择" :disabled="modifyType">
              <el-option v-for="(item, index) in clearingFromIdList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="periodType" prop="periodType" :rules="[{ required: true, message: '请选择结算周期', trigger: 'change' }]">
            <span slot="label">结算周期</span>
            <el-select v-model="formDate.periodType" style="width: 100px" placeholder="请选择" :disabled="modifyType">
              <el-option :key="1" label="每月" :value="1"></el-option>
              <el-option :key="2" label="每3月" :value="2"></el-option>
              <el-option :key="3" label="每6月" :value="3"></el-option>
              <el-option :key="4" label="每12月" :value="4"></el-option>
            </el-select>
            <el-input v-model="formDate.periodDay" style="width: 70px; margin-left: 5px" placeholder="请输入" :disabled="modifyType" />日-下一周期首月{{
              formDate.periodDay ? (formDate.periodDay == 1 ? 30 : formDate.periodDay - 1) : ""
            }}日
          </el-form-item>
          <el-form-item prop="paymentMethod" :rules="[{ required: true, message: '请选择付款方式', trigger: 'change' }]">
            <span slot="label">付款方式</span>
            <el-select v-model="formDate.paymentMethod" placeholder="请选择" :disabled="modifyType">
              <el-option label="账龄" :value="1"></el-option>
              <el-option label="比例" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item v-show="formDate.paymentMethod == 1" prop="aging" :rules="[{ required: formDate.paymentMethod == 1, message: '请选择账龄', trigger: 'change' }]">
            <span slot="label">账龄</span>
            <el-select v-model="formDate.aging" placeholder="请选择" :disabled="modifyType">
              <el-option label="1月" :value="1"></el-option>
              <el-option label="2月" :value="2"></el-option>
              <el-option label="3月" :value="3"></el-option>
              <el-option label="4月" :value="4"></el-option>
              <el-option label="5月" :value="5"></el-option>
              <el-option label="6月" :value="6"></el-option>
              <el-option label="7月" :value="7"></el-option>
              <el-option label="8月" :value="8"></el-option>
              <el-option label="9月" :value="9"></el-option>
              <el-option label="10月" :value="10"></el-option>
              <el-option label="11月" :value="11"></el-option>
              <el-option label="12月" :value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="formDate.paymentMethod == 2" prop="paymentRatio" :rules="[{ required: formDate.paymentMethod == 2, message: '请输入支付比例', trigger: 'change' }]">
            <span slot="label">支付比例(%)</span>
            <el-input-number v-model="formDate.paymentRatio" :precision="2" style="width: 130px" :max="100" :disabled="modifyType" :controls="false"></el-input-number>
          </el-form-item> -->
          <!-- 新增字段修改  进度支付时段（账龄）、支付比例、尾款支付、尾款支付时段  -->
          <el-form-item prop="transitionPeriod" class="zq" label-width="180px">
            <span slot="label">进度支付时段（账龄）</span>
            <el-input-number v-model="formDate.transitionPeriod" style="width: 50px !important; margin-right: 10px" :disabled="modifyType" :controls="false"></el-input-number>
            <el-select v-model="formDate.periodUnit" placeholder="请选择" :disabled="modifyType">
              <el-option label="月" :value="1"></el-option>
              <el-option label="季度" :value="2"></el-option>
              <el-option label="年" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="payRatio" class="zq">
            <span slot="label">支付比例</span>
            <el-input-number v-model="formDate.payRatio" style="width: 50px !important; margin-right: 10px" :disabled="modifyType" :controls="false"></el-input-number>
            <span>%</span>
          </el-form-item>
          <el-form-item prop="balancePayment" class="zq">
            <span slot="label">尾款支付</span>
            <el-select v-model="formDate.balancePayment" placeholder="请选择" :disabled="modifyType">
              <el-option label="总结算后" :value="1"></el-option>
              <el-option label="合同有效期内" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="balancePaymentPeriod" class="zq" label-width="180px">
            <span slot="label">尾款支付时段<span v-if="formDate.balancePayment == 2">（账龄）</span> </span>
            <el-input-number v-model="formDate.balancePaymentPeriod" style="width: 50px !important; margin-right: 10px" :disabled="modifyType" :controls="false"></el-input-number>
            <el-select v-model="formDate.balanceUnit" placeholder="请选择" :disabled="modifyType">
              <el-option label="月" :value="1"></el-option>
              <el-option label="季度" :value="2"></el-option>
              <el-option label="年" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">结算说明</span>
            <el-input v-model="formDate.explains" style="width: 800px" type="textarea" placeholder="请输入" clearable :rows="2" resize="none" :disabled="modifyType" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <!-- <div class="form-title">增值服务</div>
          <el-form-item prop="processModel">
            <span slot="label">流程模式</span>
            <el-select v-model="formDate.processModel" placeholder="请选择" :disabled="modifyType" @change="processModelFun()">
              <el-option label="传统工艺流程模式" value="1"></el-option>
              <el-option label="电子工艺流程模式" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label"></span>
            <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="stationsControlPointFun()">管控业务点</el-button>
          </el-form-item> -->
          <div class="form-title">附件</div>
          <FileComponent fileCode="contractFile" :disabled="modifyType" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog = false">关 闭</el-button>
        <el-button v-show="!modifyType" class="bottom_all" style="margin-left: 24px" :disabled="modifyType" @click="pagessubmitFromDate()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 业务管控点 -->
    <el-dialog v-dialogDrag :visible.sync="controlPoint_Dialog" width="800px">
      <span slot="title" class="dialog-title">管控业务点设置</span>
      <div class="dialoginfo">
        <div class="FZYguanKongYeWuDian">
          <table>
            管控业务点：
          </table>
          <div class="FZYcheckbox">
            <div v-if="formDate.processModel == 1">
              <el-checkbox v-for="(v, k) in businessCheckbox" :key="k" :label="v.id" :disabled="true" checked>{{ v.itemName }}</el-checkbox>
            </div>
            <el-checkbox-group v-else v-model="formDate.business">
              <el-checkbox v-for="item in businessCheckbox" :key="item.id" :label="item.id" :disabled="modifyType">{{ item.itemName }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all" style="margin-left: 24px" @click="controlPoint_Dialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 站点运输价及到岸价查看 -->
    <el-dialog v-dialogDrag :visible.sync="thePrice_Dialog" width="550px">
      <span slot="title" class="dialog-title">站点运输价及到岸价</span>
      <div class="dialoginfo"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="thePrice_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 协作单位 -->
    <el-dialog v-dialogDrag :visible.sync="cooperativeUnit_Dialog" width="550px">
      <span slot="title" class="dialog-title">协作单位</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="cooperativeUnitArr" tooltip-effect="dark">
          <el-table-column label="协作单位" align="center" prop="name"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="cooperativeUnit_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 合同产品列表 -->
    <el-dialog v-dialogDrag :visible.sync="riseInPriceQueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">合同产品列表</span>
      <div class="dialoginfo">
        <div class="form-title">运距价格设置</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[{ id: 1, name: '运距调价' }]" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="运距调价" align="center" width="250" prop="name"></el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="form-title">泵送价格设置</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpPriceArr" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="泵车类型" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled style="width: 100% !important">
                <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="form-title">产品价格设置</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="goodPriceArr" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="强度等级" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled style="width: 100% !important">
                <el-option v-for="item in goodPriceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, false)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="form-title">附加收费项价格</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="fuPriceArr" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="附加收费项" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled style="width: 100% !important">
                <el-option v-for="item in fuPriceList" :key="item.ID" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="附加收费" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, false)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="riseInPriceQueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 价格区间弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="basePriceListType" width="800px">
      <span slot="title" class="dialog-title">设置泵送高度</span>
      <div class="dialoginfo FZY1-3">
        <div v-for="(v3, k3) in carTwosArr" :key="k3">
          <div v-if="k3 == 0" class="liBox1">
            <div>
              <span>小于等于</span>
              <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2" :disabled="modifyType" @blur="inpuSizeCheck2(v3.distance, k3, carTwosArr)"></el-input-number>
            </div>
            <div>
              <span>米</span>
              <b>：</b>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
              <span>元/方</span>
            </div>
          </div>
          <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
            <div>
              <div>
                <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
                <span>至</span>
                <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2" :disabled="modifyType" @blur="inpuSizeCheck2(v3.distance, k3, carTwosArr)"></el-input-number>
              </div>
              <div>
                <span>米</span>
                <b>：</b>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
                <span>元/方</span>
              </div>
            </div>
            <div>
              <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType" @click="addJson2()">添加区间</el-button>
              <el-button v-else class="bottom_text" :disabled="modifyType" @click="delJson2(k3)">删除区间</el-button>
            </div>
          </div>
          <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
            <div>
              <span>大于</span>
              <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
            </div>
            <div>
              <span>米</span>
              <b>：</b>
              <span>每增加</span>
              <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
              <span>米，增加</span>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
              <span>元/方</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="basePriceListType = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="basePriceListUpFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 价格设置-调价详情 -->
    <el-dialog v-dialogDrag :visible.sync="QueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">价格设置</span>
      <div class="dialoginfo">
        <div v-show="$options.filters.moneyFun(moneyType)" class="FZY1-3" style="border-bottom: 0px; margin-bottom: 10px">
          <div v-for="(v3, k3) in carTwosArr" :key="k3">
            <div v-if="k3 == 0" class="liBox1">
              <div>
                <span>小于</span>
                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
              </div>
              <div>
                <span>千米</span>
                <b>：</b>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
                <span>元/方</span>
              </div>
            </div>
            <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
              <div>
                <div>
                  <el-input-number
                    v-model="v3.minDistance"
                    size="mini"
                    :controls="false"
                    :precision="2"
                    :disabled="modifyType"
                    @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                    @blur="inpuSizeCheck3(v3.minDistance, k3, carTwosArr)"
                  ></el-input-number>
                  <span>至</span>
                  <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
                </div>
                <div>
                  <span>千米</span>
                  <b>：</b>
                  <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" :disabled="modifyType"></el-input-number>
                  <span>元/方</span>
                </div>
              </div>
              <div>
                <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType" @click="addJson2()">添加区间</el-button>
                <el-button v-else class="bottom_text" :disabled="modifyType" @click="delJson2(k3)">删除区间</el-button>
              </div>
            </div>
            <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
              <div>
                <span>大于</span>
                <el-input-number
                  v-model="v3.minDistance"
                  size="mini"
                  :controls="false"
                  :precision="2"
                  :disabled="modifyType"
                  @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                  @blur="inpuSizeCheck3(v3.minDistance, k3, carTwosArr)"
                ></el-input-number>
              </div>
              <div>
                <span>千米</span>
                <b>：</b>
                <span>每增加</span>
                <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
                <span>千米，增加</span>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px" :disabled="modifyType"></el-input-number>
                <span>元/方</span>
              </div>
            </div>
          </div>
        </div>
        <el-form ref="contractRawMoneySaveForm" label-width="80px" :model="contractRawMoneySaveForm" :rules="contractRawMoneySaveFormRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item v-if="!$options.filters.moneyFun(moneyType)" label="价格" prop="money">
                <el-input v-model="contractRawMoneySaveForm.money" type="Number" placeholder>
                  <template slot="append">元/吨</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效日期" prop="startTime">
                <el-date-picker v-model="contractRawMoneySaveForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="margin-left: 24px"><FileComponent2 fileCode="contractFile" :files="files2" @deleteFile="deleteFile2" @uplodeSuccess="uplodeSuccess2" /></div>
            </el-col>
            <el-col :span="2" style="margin-bottom: 20px">
              <el-button class="bottom_all" @click="contractRawMoneySaveFun()">添加</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="QueryOneByidArr" tooltip-effect="dark">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="价格" prop="money" align="center">
            <template slot-scope="scope">
              <el-link v-if="$options.filters.moneyFun(moneyType)" class="table_link" :underline="false" @click="basePriceListFun2(scope.row)">查看</el-link>
              <span v-else>{{ scope.row.money }} 元/吨</span>
            </template>
          </el-table-column>
          <el-table-column label="生效日期" prop="startTime" align="center"></el-table-column>
          <el-table-column label="附件" align="center" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="contractRawMoneyDeletesFun(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="$options.filters.moneyFun(moneyType)" class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ QueryOneByidObject.total }}条</div>
            <el-pagination
              :current-page.sync="QueryOneByidObject.page"
              :page-size="QueryOneByidObject.pageSize"
              layout="prev, pager, next, jumper"
              :total="QueryOneByidObject.total"
              @current-change="QueryOneByidFun()"
            ></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="QueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 价格区间弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="basePriceListType2" width="800px">
      <span slot="title" class="dialog-title">泵送高度及价格</span>
      <div class="dialoginfo FZY1-3">
        <div v-for="(v3, k3) in carTwosArr2" :key="k3">
          <div v-if="k3 == 0" class="liBox1">
            <div>
              <span>小于</span>
              <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
            </div>
            <div>
              <span>千米</span>
              <b>：</b>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" disabled></el-input-number>
              <span>元/方</span>
            </div>
          </div>
          <div v-if="k3 > 0 && k3 != carTwosArr2.length - 1" class="liBox3">
            <div>
              <div>
                <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
                <span>至</span>
                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
              </div>
              <div>
                <span>千米</span>
                <b>：</b>
                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" disabled></el-input-number>
                <span>元/方</span>
              </div>
            </div>
          </div>
          <div v-if="k3 == carTwosArr2.length - 1" class="liBox2" style="width: 100%">
            <div>
              <span>大于</span>
              <el-input-number v-model="carTwosArr2[k3 - 1].maxDistance" size="mini" :controls="false" :precision="2" disabled></el-input-number>
            </div>
            <div>
              <span>千米</span>
              <b>：</b>
              <span>每增加</span>
              <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0" style="width: 80px" disabled></el-input-number>
              <span>千米，增加</span>
              <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px" disabled></el-input-number>
              <span>元/方</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="basePriceListType2 = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息 -->
    <el-dialog v-dialogDrag :visible.sync="AllqueryListsByPid" width="550px">
      <span slot="title" class="dialog-title">开户信息维护</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="queryListsByPidArr" tooltip-effect="dark">
          <el-table-column label="单位名称" prop="name" align="center"></el-table-column>
          <el-table-column label="开户信息" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="contractAccountGetDetailFun(scope.row, scope.$index + 1)">开户信息</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="AllqueryListsByPid = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息详情-编辑 -->
    <el-dialog v-dialogDrag :visible.sync="contractAccountGetDetailType" width="800px">
      <span slot="title" class="dialog-title">开户信息</span>
      <div class="dialoginfo">
        <el-form ref="contractAccountSaveForm" label-width="130px" :model="contractAccountSaveForm" :rules="contractAccountSaveRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="法定代表人" prop="name" :rules="[{ required: true, message: '请输入法定人', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人身份证号码" prop="identityCard">
                <el-input v-model="contractAccountSaveForm.identityCard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同条款" prop="contractPact" :rules="[{ required: true, message: '请输入合同条款', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.contractPact"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode" :rules="[{ required: true, message: '请输入信用代码', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.unifiedSocialCreditCode"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">现金</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountA"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">电子承兑</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountB"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">商票</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountC"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">其他</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountD"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="contractAccountGetDetailType = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="contractAccountSaveFun()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 列表单选 -->
    <el-dialog v-dialogDrag :visible.sync="ListChoiceType" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          <div class="form-title">原物料查询</div>
          <div style="position: absolute; right: 0; top: 0">
            名称：
            <el-input v-model="checkName" size="mini" style="width: 120px"></el-input>
            <!-- 规格：
            <el-input v-model="checkSpec" size="mini" style="width: 120px"></el-input> -->
            类型：
            <el-select v-model="checkTypeId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(v, k) in checkTypeIdList" :key="k" :label="v.itemName" :value="v.id"></el-option>
            </el-select>
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="ListChoicePagingFun()">搜索</el-button>
          </div>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="ListChoiceData"
          tooltip-effect="dark"
          highlight-current-row
          @row-click="ListChoiceFun"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="ListChoiceRadio" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="原物料编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="name" label="原物料名称" width="auto" align="center"></el-table-column>
          <el-table-column prop="brand" label="品牌" width="auto" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" width="auto" align="center"></el-table-column>
          <el-table-column prop="originPlace" label="产地" width="auto" align="center"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="auto" align="center"></el-table-column>
          <el-table-column prop="enable" label="状态" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
              <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="ListChoicePaging.page"
          :page-size="ListChoicePaging.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="ListChoicePaging.total"
          @current-change="ListChoicePagingFun(true)"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ListChoiceType = false">取 消</el-button>
        <el-button :disabled="modifyType" class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 列表单选2 -->
    <el-dialog v-dialogDrag :visible.sync="ListChoiceType2" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择</span>
      <div class="dialogOtherinfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          <div class="form-title">供应商查询查询</div>
          <div style="position: absolute; right: 0; top: 0">
            供应商:
            <el-input v-model="supplierName" size="mini" style="width: 120px"></el-input>
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="ListChoicePagingFun2()">搜索</el-button>
          </div>
        </div>
        <el-table
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="ListChoiceData2"
          tooltip-effect="dark"
          highlight-current-row
          @row-click="ListChoiceFun2"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="ListChoiceRadio2" :label="scope.row.id">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="code" label="合同编号" width="auto" align="center"></el-table-column>
          <el-table-column prop="rawName" label="原物料" width="auto" align="center"></el-table-column> -->
          <el-table-column prop="name" label="供应商" width="auto" align="center"></el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="ListChoicePaging2.page"
          :page-size="ListChoicePaging2.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="ListChoicePaging2.total"
          @current-change="ListChoicePagingFun2(true)"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="ListChoiceType2 = false">取 消</el-button>
        <el-button :disabled="modifyType" class="bottom_all" style="margin-left: 24px" @click="ListChoiceAddFun2()">确 定</el-button>
      </span>
    </el-dialog>
    <ModifyTheRecord ref="ModifyTheRecord"></ModifyTheRecord>
    <diaLog1 :dialog="dialog1" :low="low" :supplierId="supplierId" :tableData="roleList" @reset="reset1" @submit="submit"></diaLog1>
    <diaLog2 :dialog="dialog2" :low="low2" @reset="reset1"></diaLog2>
    <!-- 查看附件 -->
    <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
  </div>
</template>

<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import LookFile from "@/components/File/LookFile";
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import FileComponent3 from "./fileComponent";
import {
  queryPage,
  batchUpdateOrDelete,
  updateSortNum,
  saveOrUpdate,
  Download,
  // engineeringManagementQueryPage,
  processes_collection,
  contractSaveOrUpdate,
  contractQueryDetailById,
  QueryOneByid,
  contractRawMoneySave,
  contractRawMoneyDeletes,
  contractAccountGetDetail,
  contractAccountSave,
  PumpPriceLogQueryPage,
  PumpPriceLogSave,
  PumpPriceLogGetDetail,
  PumpPriceLogDeletes,
  queryContractNumber,
  rawMaterialsQueryPage,
  supplierQueryPage,
} from "@/api/GHnumber/outsourcing.js";
import { querysupplierPage, queryListsByPid } from "@/api/GHnumber/supplier.js";
import { queryMaterialsPage } from "@/api/basicConfig/Rmaterial.js";
import { getDicType, getDicsType } from "@/api/common.js";
import { getListByTypeId } from "@/api/common.js";
import { getLists } from "@/api/basicConfig/CCTrules.js";
import { getLists as getLists2 } from "@/api/smart/schedul/c.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
import ModifyTheRecord from "./modifyTheRecord";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
const diaLog1 = () => import("../dialog/contract1");
const diaLog2 = () => import("./dialog/engineeringControl1");
export default {
  components: { FileComponent, ModifyTheRecord, diaLog1, diaLog2, FileComponent2, LookFile, FileComponent3 },
  mixins: [mixin],
  watch: {
    "formDate.startDayendDay"() {
      this.formDate.startDay = this.formDate.startDayendDay[0];
      this.formDate.endDay = this.formDate.startDayendDay[1];
    },
    yiFenPeiRadio: {
      handler: function (val) {
        this.ids = [val.id];
      },
      deep: false,
    },
  },
  data() {
    var userCard = (rule, value, callback) => {
      //验证身份证号码
      var reg = new RegExp(/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/);
      if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    var phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("号码不能为空!!"));
      }
      setTimeout(() => {
        if (!phoneReg.test(value)) {
          callback(new Error("格式有误"));
        } else {
          callback();
        }
      }, 100);
    };
    return {
      //分配账号角色列表
      roleList: [
        { roleName: "协外接单员", roleId: "194993877122420736", list: [], list1: [] },
        { roleName: "协外签票员", roleId: "194994613285687296", list: [], list1: [] },
        { roleName: "协外结算员", roleId: "194995280494596096", list: [], list1: [] },
        { roleName: "协外异常处理员", roleId: "194996136325550080", list: [], list1: [] },
      ],
      roadWorkList: [], // 合同签订主体数据
      lookFileVisible: false,
      lookFileConfig: {},
      low: "",
      low2: {},
      dialog1: false,
      dialog2: false,
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      aaaaaaaaa: [],
      files: [],
      files2: [],
      files3: [],
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete, //启用禁用接口
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "合同ID", width: "120", prop: "code", status: true },
        { label: "合同类型", width: "120", prop: "contractType", status: true },
        {
          label: "合同签订主体",
          width: "auto",
          prop: "contractSigningSubject",
          status: true,
        },
        { label: "站点名称", width: "120", prop: "stations", status: true },
        {
          label: "主合同单位",
          width: "auto",
          prop: "supplierName",
          status: true,
        },
        {
          label: "供应商类别",
          width: "120",
          prop: "supplierType",
          status: true,
        },
        {
          label: "合同编号",
          width: "auto",
          prop: "contractNumber",
          status: true,
        },
        {
          label: "合同签订情况",
          width: "auto",
          prop: "concludeAndSignStatus",
          status: true,
        },
        {
          label: "华西云采注册情况",
          width: "120",
          prop: "loginStatus",
          status: true,
        },
        { label: "合同有效期", width: "145", prop: "startDay", status: true },
        {
          label: "招标编号",
          width: "120",
          prop: "callForBidsNumber",
          status: true,
        },
        {
          label: "合作等级",
          width: "auto",
          prop: "cooperationClass",
          status: true,
        },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true, fixed: "right" },
      ],
      modifyType: false, //修改是否可以状态
      text: "含水率规则：0≤x≤5%，按照5%结算；5%＜X≤8%，按照8%结算；8%<x≤13%，按照实测结算；13%<x，按照实测结算，并5元/吨处罚",
      clearingFromIdList: [
        // { id: '0', name: '双控' },
        // { id: '1', name: '图算' },
        { id: "2", name: "实结" },
      ], //结算方式
      companylist: [], //甲方公司
      sitelist: [], //站点名称
      supplierList: [], //主合同单位名称
      MaterialsList: [], //原物料
      AForContract: [], //是否甲供合同
      theUnitPriceSource: [
        {
          id: "1",
          itemName: "已信息价结算",
        },
        {
          id: "2",
          itemName: "已内部价结算",
        },
        {
          id: "3",
          itemName: "已市场价结算",
        },
        {
          id: "4",
          itemName: "已出厂价结算",
        },
        {
          id: "5",
          itemName: "已到岸价结算",
        },
      ], //单价来源
      engineeringManagement: [], //甲供工程
      thePrice_Dialog: false, //价格表弹窗
      controlPoint_Dialog: false, //业务管控点弹窗
      cooperativeUnit_Dialog: false, //协作单位弹窗
      rules: {
        contractContractType: [{ required: true, message: "请选择合同类型", trigger: "change" }],
        splitMode: [{ required: true, message: "请选择拆分方式", trigger: "change" }],
        firstPartyId: [{ required: true, message: "请选择甲方公司", trigger: "change" }],
        contractSigningSubjectId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
        supplierId: [{ required: true, message: "请选择主合同单位", trigger: "change" }],
        contractNumber: [{ required: true, message: "请输入合同编号", trigger: "change" }],
        callForBidsNumber: [{ required: true, message: "请输入招标编号", trigger: "change" }],
        concludeAndSignStatus: [{ required: true, message: "请选择合同签订情况", trigger: "change" }],
        loginStatus: [
          {
            required: true,
            message: "请选择华西云采注册情况",
            trigger: "change",
          },
        ],
        linkman: [{ required: true, message: "请输入联系人", trigger: "change" }],
        phone: [{ required: true, validator: validatePhone, trigger: "change" }],
        startDayendDay: [{ required: true, message: "请选择合同有效期", trigger: "change" }],
        clearingFormId: [{ required: true, message: "请选择结算方式", trigger: "change" }],
        adjustMethod: [{ required: true, message: "请选择调价方式", trigger: "change" }],
        processingPrice: [{ required: true, message: "请输入加工价", trigger: "change" }],
        processModel: [{ required: true, message: "请选择流程模式", trigger: "change" }],
        taxRate: [{ required: true, message: "请输入税率", trigger: "change" }],
        performanceRequirementsArr: [{ required: true, message: "请选择性能等级", trigger: "change" }],
        materialRequirementsArr: [{ required: true, message: "请选择材料要求", trigger: "change" }],
        specialRequirementsArr: [{ required: true, message: "请选择特殊要求", trigger: "change" }],
        otherRequirementsArr: [{ required: true, message: "请选择其他要求", trigger: "change" }],
        additiveRequirementsArr: [{ required: true, message: "请选择外加剂要求", trigger: "change" }],
        pouringMethodArr: [{ required: true, message: "请选择泵送方式", trigger: "change" }],
        strengthGradeArr: [{ required: true, message: "请选择强度等级", trigger: "change" }],
        pumpCompensation: [{ required: true, message: "请选择泵送方", trigger: "change" }],
        transportCompensation: [{ required: true, message: "请选择运输方", trigger: "change" }],
      },
      formDate: {
        userType: [],
        stationsList: [],
        stations: "",
        startDayendDay: [],
        id: "",
        contractTypeId: "6",
        contractType: "协外",
        contractContractType: "", //合同的合同类型
        splitMode: "", //拆分方式
        pumpCompensation: "", //泵送方
        pumpCompensationPrice: "", //泵送价格
        transportCompensation: "", //运输方
        transportCompensationPrice: "", //运输价格
        strengthGrade: "", //强度等级
        strengthGradeArr: [], //强度等级
        performanceRequirements: "", //性能等级
        performanceRequirementsArr: [], //性能等级
        materialRequirements: "", //材料要求
        materialRequirementsArr: [], //材料要求
        specialRequirements: "", //特殊要求
        specialRequirementsArr: [], //特殊要求
        otherRequirements: "", //其他要求
        otherRequirementsArr: [], //其他要求
        additiveRequirements: "", //外加剂要求
        additiveRequirementsArr: [], //外加剂要求
        pouringMethod: "", //泵送方式
        pouringMethodArr: [], //泵送方式
        firstParty: "", //甲方
        contractSigningSubjectId: "", // 合同签订主体
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        oilPrice: "",
        firstSupplyName: "", //甲供合同
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        periodType: "", //结算周期类型
        periodDay: "", //结算周期
        adjustMethod: 1, //补充协议
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        business: [], //业务点1，2，3
        cargoTypeId: 1, //货物类型
        foreign: {
          yunPrice: [
            {
              id: "",
              costName: 1, //距离
              costUnit: 0, //价格
              type: 1, //1新增；2修改 0删除
            },
            {
              id: "",
              costName: 2, //距离
              costUnit: 0, //价格
              type: 1, //1新增；2修改 0删除
            },
            {
              id: "",
              costName: 9999999, //距离
              costUnit: 0, //价格
              type: 1, //1新增；2修改 0删除
            },
          ],
          pumpPrice: [], //泵送价格
          goodPrice: [], //强度等级价格
          fuPrice: [], //附加收费项价格
          splitPrice: [],
        },
      },
      businessCheckbox: [], //业务点
      businessCheckbox1: [{ itemName: "呜呜呜呜", id: 111 }],
      cooperativeUnitArr: [], //协外单位列表
      riseInPriceQueryOneByidType: false,
      riseInPriceQueryOneByidArr: [], //调价列表
      contractId: "", //原物料列表
      QueryOneByidType: false,
      QueryOneByidArr: [], //调价列表
      pumpTypeArr: [], //泵车类型
      cargoTypeIdArr: [
        {
          id: 1,
          name: "原物料",
        },
        {
          id: 2,
          name: "混凝土",
        },
        {
          id: 3,
          name: "其他",
        },
      ],
      QueryOneByidObject: {
        //调价分页
        page: 1,
        pageSize: 10,
        total: 0,
      },
      contractRawMoneySaveForm: { startTime: "" },
      contractRawMoneySaveFormRules: {
        money: [{ required: true, message: "请输入价格", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择生效日期", trigger: "blur" }],
      },
      AllqueryListsByPid: false,
      queryListsByPidArr: [], //开户信息-协作单位合并列表
      contractAccountGetDetailType: false,
      //开户信息表单
      contractAccountSaveForm: {
        contractPactId: "", //合同条约id
        contractPact: "", //合同条约
      },
      contractAccountSaveRules: {
        identityCard: [{ required: true, validator: userCard, trigger: "change" }], //身份证
      },
      yunPriceArr: [], //价格区间
      pumpPriceArr: [], //泵送价格
      goodPriceArr: [], //强度等级价格
      fuPriceArr: [], //附加收费项价格
      goodPriceList: [], //强度list
      fuPriceList: [], //附加收费项list
      cplistArr: [], //供应产品列表显示部分
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], // 其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pumpTypeList: [], //浇筑方式泵机类型
      carTwosArr: [], //区间价格弹窗数组
      carTwosArrIndex: "", //当前打开的价格弹窗数组对应的表格里面的下标
      basePriceListType: false, //设置区间价格弹窗
      basePriceListType2: false, //区间价格仅仅查看的弹窗
      carTwosArr2: [], //区间价格弹窗数组
      pumpListArr: [], //泵管价格
      moneyType: false, //当前是否打开的是泵车价格
      appPackage: [],
      yiFenPeiRadio: "",
      supplierId: "",
      taxRateList: [],
      otherStationArr: [], //协外站点list
      splitPriceArr: [], //工控拆分List
      ListChoiceType: false, //单选表格是否打开
      ListChoiceData: [], //单选表格数据
      ListChoiceRadio: "", //单选表格选中项
      ListChoiceRadioCopy: "", //当前打开的单选表格选中项
      ListChoiceRadioRow: {}, //单选表格选中的对象
      ListChoiceDataIndex: "", //点击的表格数据下标
      ListChoicePaging: {
        //单选表格分页
        pageSize: 5,
        page: 1,
        total: 0,
        name: "",
        enable: 1,
      },
      ListChoiceType2: false, //单选表格是否打开
      ListChoiceData2: [], //单选表格数据
      ListChoiceRadio2: "", //单选表格选中项
      ListChoiceRadioCopy2: "", //当前打开的单选表格选中项
      ListChoiceRadioRow2: {}, //单选表格选中的对象
      ListChoiceDataIndex2: "", //点击的表格数据下标
      ListChoicePaging2: {
        //单选表格分页
        pageSize: 5,
        page: 1,
        total: 0,
        enable: 1,
        name: "",
      },
      supplierName: "",
      checkName: "",
      checkSpec: "",
      checkTypeId: "",
      checkTypeIdList: [],
      //特殊运载
      noPumpList: [],
      specialTransport: [],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companylist = await getUserAutList();
    const arr = this.companylist.map(item => item.children);
    arr.forEach(item => {
      item.forEach(sItem => {
        this.sitelist.push(sItem);
      });
    });
    getLists().then(res => {
      res.data.forEach(v => {
        if (v.typeName == "材料要求") {
          this.fuPriceList = v.list;
        }
      });
    });
    getListByTypeId({
      typeId: 1,
    }).then(res => {
      this.goodPriceList = res.data;
    });
    let params = {
      page: 1,
      pageSize: 99999,
    };
    // engineeringManagementQueryPage({
    //   isAssess: 1,
    //   page: 1,
    //   pageSize: 99999,
    // }).then(res => {
    //   this.engineeringManagement = res.data.data;
    // });
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
    });
    queryMaterialsPage().then(res => {
      this.MaterialsList = res.data;
    });
    getDicType({ code: "castingType" }).then(res => {
      this.pumpTypeArr = res.data.items; //
    });
    getDicType({ code: "contractType" }).then(res => {
      this.contractTypeArry = res.data.items; //
    });
    getDicType({ code: "HuaXiYunCai_Registration" }).then(res => {
      this.HuaXiYunCai_RegistrationArry = res.data.items; //
    });
    getDicType({ code: "AForContract" }).then(res => {
      this.AForContract = res.data.items; //
    });
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    getDicType({ code: "hetongsuilv" }).then(res => {
      this.taxRateList = res.data.items;
      this.taxRateList.forEach(item => {
        item.itemValue = Number(item.itemValue);
      });
    });
    getDicType({ code: "MATtype" }).then(res => {
      this.checkTypeIdList = res.data.items; //
    });
    /**浇筑方式泵机类型 */
    getDicType({
      code: "castingType",
    }).then(res => {
      res.data.items.map(v1 => (v1.type = 1));
      this.pumpTypeList = res.data.items;
      /*获取非泵送浇筑方式 */
    console.log('+++++++++++++++++++++++++++++++++++')
    getDicType({ code: "pouringMethod" }).then(res => {
      this.noPumpList = res.data.items; //
      let noPumpList2 = res.data.items;
      noPumpList2.map(v1 => (v1.type = 2));
      console.log('----------------------------------')
      this.pumpTypeList = [...this.pumpTypeList, ...noPumpList2];
    });
    });
    
    /**
     * @Description: 获取5大参数
     * @Param:
     * @Author: wangwangwang
     */
    getLists2().then(res => {
      res.data.forEach(item => {
        if (!item) return;
        if (item.typeName == "强度等级") {
          this.strengthGradeList = item.list;
        } else if (item.typeName == "规范性能等级") {
          this.performanceGradeList = item.list;
        } else if (item.typeName == "材料要求") {
          this.meterialRequirementsList = item.list;
        } else if (item.typeName == "特殊要求") {
          this.specialRequirementsList = item.list;
        } else if (item.typeName == "外加剂要求") {
          this.admixtureRequirementsList = item.list;
        } else if (item.typeName == "其他要求") {
          this.otherRequirementsList = item.list;
        }
      });
    });
  },
  methods: {
    //判断协外站点选择是否重复
    sourcingOutStation(row, index) {
      let num = this.otherStationArr.findIndex((item, index2) => item.id == row.id && index !== index2);
      if (num !== -1) {
        this.$message.warning("该站点已经被选择,请重新添加!");
        row.id = "";
        row.name = "";
      }
    },
    //产品信息开始
    selectAll1() {
      if (this.checked1) {
        this.formDate.strengthGradeArr = this.strengthGradeList.map(item => item.id);
      } else {
        this.formDate.strengthGradeArr = [];
      }
    },
    selectAll2() {
      if (this.checked2) {
        this.formDate.performanceRequirementsArr = this.performanceGradeList.map(item => item.id);
      } else {
        this.formDate.performanceRequirementsArr = [];
      }
    },
    selectAll3() {
      if (this.checked3) {
        this.formDate.materialRequirementsArr = this.meterialRequirementsList.map(item => item.id);
      } else {
        this.formDate.materialRequirementsArr = [];
      }
    },
    selectAll4() {
      if (this.checked4) {
        this.formDate.specialRequirementsArr = this.specialRequirementsList.map(item => item.id);
      } else {
        this.formDate.specialRequirementsArr = [];
      }
    },
    selectAll5() {
      if (this.checked5) {
        this.formDate.otherRequirementsArr = this.otherRequirementsList.map(item => item.id);
      } else {
        this.formDate.otherRequirementsArr = [];
      }
    },
    selectAll6() {
      if (this.checked6) {
        this.formDate.additiveRequirementsArr = this.admixtureRequirementsList.map(item => item.id);
      } else {
        this.formDate.additiveRequirementsArr = [];
      }
    },
    selectAll7() {
      if (this.checked7) {
        this.formDate.pouringMethodArr = this.pumpTypeList.map(item => item.id);
      } else {
        this.formDate.pouringMethodArr = [];
      }
    },
    //产品信息结束
    //工控拆分开始
    /**单选列表打开 */
    ListChoiceTypeFun(index, id) {
      // if (!this.formDate.firstPartyId) {
      //   this.$message({
      //     message: "请先选择权限公司！",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.ListChoiceType = true;
      this.ListChoiceDataIndex = index;
      if (id) {
        this.ListChoiceRadio = id;
        this.ListChoiceRadioCopy = id;
      } else {
        this.ListChoiceRadio = "";
        this.ListChoiceRadioCopy = "";
      }
      this.checkName = "";
      this.checkTypeId = "";
      this.ListChoicePagingFun();
    },
    //单选选中
    ListChoiceFun(currentRow) {
      if (currentRow) {
        console.log(this.ListChoiceRadio + ";" + currentRow.id);
        let type = this.splitPriceArr.findIndex(res => res.rawId == currentRow.id);
        if (type == -1 || this.ListChoiceRadioCopy == currentRow.id) {
          this.ListChoiceRadio = currentRow.id;
          this.ListChoiceRadioRow = currentRow;
        } else {
          this.$message({
            message: "该选项已被选择！",
            type: "warning",
          });
          setTimeout(() => {
            this.ListChoiceRadioRow = "";
          }, 100);
        }
      }
    },
    /**保存和校验不重复选中项 */
    ListChoiceAddFun() {
      //原物料选择后对应值【品牌，规格..】带入表格中
      this.splitPriceArr[this.ListChoiceDataIndex].rawId = this.ListChoiceRadioRow.id;
      this.splitPriceArr[this.ListChoiceDataIndex].rawMaterialName = this.ListChoiceRadioRow.name + "_" + this.ListChoiceRadioRow.specification + "_" + this.ListChoiceRadioRow.brand + "_" + this.ListChoiceRadioRow.originPlace;
      this.splitPriceArr[this.ListChoiceDataIndex].rawMaterialId = this.ListChoiceRadioRow.rawId;
      this.splitPriceArr[this.ListChoiceDataIndex].specification = this.ListChoiceRadioRow.specification;
      this.splitPriceArr[this.ListChoiceDataIndex].specificationId = this.ListChoiceRadioRow.specificationId;
      // this.splitPriceArr[this.ListChoiceDataIndex].rawMaterialContractId = "";
      // this.splitPriceArr[this.ListChoiceDataIndex].contractCode = "";
      // this.splitPriceArr[this.ListChoiceDataIndex].supperId = "";
      // this.splitPriceArr[this.ListChoiceDataIndex].supperName = "";
      console.log(this.splitPriceArr);
      this.ListChoiceType = false;
    },
    /**分页查询列表 */
    ListChoicePagingFun(type) {
      if (!type) {
        this.ListChoicePaging.page = 1;
        // this.ListChoicePaging.specification = this.checkSpec;
        this.ListChoicePaging.name = this.checkName;
        this.ListChoicePaging.typeId = this.checkTypeId;
      }
      // let json = [this.formDate.firstPartyId];
      // this.ListChoicePaging.id = json.join(",");
      console.log(this.ListChoicePaging);
      rawMaterialsQueryPage(this.ListChoicePaging).then(res => {
        this.ListChoiceData = res.data.data;
        this.ListChoicePaging.total = res.data.totalRows;
      });
    },
    /**单选列表打开 */
    ListChoiceTypeFun2(index, id) {
      this.ListChoiceType2 = true;
      this.ListChoiceDataIndex2 = index;
      if (id) {
        this.ListChoiceRadio2 = id;
        this.ListChoiceRadioCopy2 = id;
      } else {
        this.ListChoiceRadio2 = "";
        this.ListChoiceRadioCopy2 = "";
      }
      this.ListChoicePagingFun2();
    },
    //单选选中
    ListChoiceFun2(currentRow) {
      if (currentRow) {
        console.log(this.ListChoiceRadio2 + ";" + currentRow.id);
        let type = this.splitPriceArr.findIndex(res => res.supperId == currentRow.id);
        if (type == -1 || this.ListChoiceRadioCopy2 == currentRow.id) {
          this.ListChoiceRadio2 = currentRow.id;
          this.ListChoiceRadioRow2 = currentRow;
        } else {
          this.$message({
            message: "该选项已被选择！",
            type: "warning",
          });
          setTimeout(() => {
            this.ListChoiceRadioRow = "";
          }, 100);
        }
      }
    },
    /**保存和校验不重复选中项 */
    ListChoiceAddFun2() {
      //原物料选择后对应值【品牌，规格..】带入表格中
      this.splitPriceArr[this.ListChoiceDataIndex].supperId = this.ListChoiceRadioRow2.id;
      this.splitPriceArr[this.ListChoiceDataIndex].supperName = this.ListChoiceRadioRow2.name;
      console.log(this.splitPriceArr);
      this.ListChoiceType2 = false;
    },
    /**分页查询列表 */
    ListChoicePagingFun2(type) {
      if (!type) {
        this.ListChoicePaging2.page = 1;
        this.ListChoicePaging2.name = this.supplierName;
      }
      supplierQueryPage(this.ListChoicePaging2).then(res => {
        this.ListChoiceData2 = res.data.data;
        this.ListChoicePaging2.total = res.data.totalRows;
      });
    },
    //工控拆分结束
    //协外站点 开始

    //协外站点 结束
    lookFile({ row }) {
      this.lookFileVisible = true;
      this.lookFileConfig = row;
    },
    /**分配账号*/
    open(low, key) {
      this.supplierId = low.supplierId;
      this.low = low.id;
      this[key] = true;
    },
    reset1(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    deleteFile2(index) {
      this.files2.splice(index, 1);
    },
    deleteFile3(index, row) {
      row.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    uplodeSuccess2(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files2.push(params);
    },
    uplodeSuccess3(data, row) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      row.files.push(params);
    },
    //暂存价格区间设置
    basePriceListUpFun() {
      /**判断区间范围是否正确--开始 */
      let type1 = false;
      let arr1 = this.carTwosArr;
      arr1.forEach((v, k) => {
        if (k > 0 && v.distance - arr1[k - 1].distance <= 0) {
          type1 = true;
        }
      });
      console.log(JSON.parse(JSON.stringify(arr1)), type1);
      /**判断区间范围是否正确--结束 */
      if (type1) {
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else {
        this.basePriceListType = false;
        this.pumpPriceArr[this.carTwosArrIndex].list = this.carTwosArr;
        console.log(JSON.parse(JSON.stringify(this.pumpPriceArr)));
      }
    },
    //价格区间设置打开
    basePriceListFun(d, index) {
      this.basePriceListType = true;
      this.carTwosArr = d;
      this.carTwosArrIndex = index;
    },
    addJson() {
      //价格区间添加
      this.yunPriceArr.splice(this.yunPriceArr.length - 1, 0, {
        id: "",
        costName: 0, //距离
        costUnit: 0, //价格
        type: 1, //1新增；2修改 0删除
      });
      this.$forceUpdate();
    },
    delJson(k) {
      //价格区间删除
      this.yunPriceArr.splice(k, 1);
    },
    addJson2() {
      //调价里面的价格区间添加
      this.carTwosArr.splice(this.carTwosArr.length - 1, 0, {
        minDistance: 0,
        maxDistance: 0,
        distance: 1, //距离
        price: 0, //价格
      });
      this.$forceUpdate();
    },
    delJson2(k) {
      //调价里面的价格区间删除
      this.carTwosArr.splice(k, 1);
      this.$forceUpdate();
    },
    processModelFun() {
      this.formDate.business = [];
    },
    //获取已选择站点名称的业务点
    stationsControlPointFun(type) {
      if (this.formDate.stationsList.length == 0) {
        this.$message({
          message: "请先选择站点！",
          type: "warning",
        });
        return;
      }
      if (this.formDate.processModel == undefined) {
        this.$message({
          message: "请先选择流程模式！",
          type: "warning",
        });
        return;
      }
      getDicsType({ codes: "collaboration,nomarket,personaluse,market" }).then(res => {
        this.businessCheckbox = [];
        res.data.market.items.forEach(v => {
          this.businessCheckbox.push(v);
        });
        if (!type) {
          this.controlPoint_Dialog = true;
          if (!this.formDate.id && this.formDate.processModel == 0) {
            processes_collection(this.formDate.stationsList).then(res2 => {
              if (res2.data?.length > 0) {
                this.formDate.business = res2.data.filter(dataRes => this.businessCheckbox.some(box => box.id == dataRes)) || [];
              }
            });
          }
        }
      });
    },
    //选择甲方公司后显示对应站点名称
    companylistChangeFun(type, companyId) {
      if (type) {
        this.formDate.stationsList = [];
      }
      this.sitelist = this.companylist.find(res => res.value == companyId).children;
    },
    //调用父级init
    init() {
      this.$emit("sumbit");
    },
    initt(data) {
      console.log(88);
      /*重置数据*/
      this.tableParam = data;
      this.gettableData();
    },
    srarch(data) {
      this.tableParam = data;
      this.gettableData();
    },
    //主合同单位选择后，带出对应参数
    async changemainCompanyId(e) {
      let item = this.supplierList.find(res => res.id == e);
      this.formDate.supplierType = item.typeName;
      this.formDate.supplierTypeId = item.typeId;
    },
    /*添加保存*/
    pagessubmitFromDate() {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          // /**判断区间范围是否正确--开始 */
          // let type1 = false;
          // let arr1 = this.yunPriceArr;
          // arr1.forEach((v, k) => {
          //   if (k > 0 && k + 1 < arr1.length && v.costName - arr1[k - 1].costName <= 0) {
          //     console.log(v.costName, arr1[k - 1].costName);
          //     type1 = true;
          //   }
          // });
          // if (type1) {
          //   this.$message({
          //     message: "区间值范围不正确，请检查！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // /**判断区间范围是否正确--结束 */
          // //运输价格数据重组-开始
          // let alldata = this.yunPriceArr.filter(res => this.formDate.foreign.yunPrice.some(item => res.id == item.id));
          // alldata.forEach(res => {
          //   res.type = 2; //2是修改
          // });
          // let deleteData = this.formDate.foreign.yunPrice.filter(res => !alldata.some(item => res.id == item.id));
          // deleteData.forEach(res => {
          //   res.type = 0; //0是删除
          // });
          // let addData = this.yunPriceArr.filter(res => !alldata.some(item => res.id == item.id));
          // this.formDate.foreign.yunPrice = [...alldata, ...deleteData, ...addData];
          // //运输价格数据重组-结束
          // let type = false;
          // this.pumpPriceArr.forEach(v => {
          //   if (!v.costId) {
          //     type = true;
          //   }
          // });
          // if (type) {
          //   this.$message({
          //     message: "请检查表格数据是否完整！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // //泵送价格数据重组-开始
          // let arr1_1 = [];
          // //第一层对比开始,通过第一层自定义字段fzyId对比
          // let alldata2 = this.pumpPriceArr.filter(res => this.formDate.foreign.pumpPrice.some(item => res.id == item.id));
          // let deleteData2 = this.formDate.foreign.pumpPrice.filter(res => !alldata2.some(item => res.id == item.id));
          // deleteData2.forEach(res => {
          //   res.type = 0; //0是删除
          // });
          // let addData2 = this.pumpPriceArr.filter(
          //   //新增的默认写死为 1；1
          //   res => !alldata2.some(item => res.id == item.id)
          // );
          // arr1_1 = [...alldata2, ...deleteData2, ...addData2];
          // // console.log(
          // //   JSON.parse(JSON.stringify(arr1_1)),
          // //   "新的第一层对比后"
          // // );
          // arr1_1.forEach((v, k) => {
          //   this.formDate.foreign.pumpPrice.forEach(v2 => {
          //     if (v.id == v2.id && v.list != null) {
          //       let alldata2 = v.list.filter(res => v2.list.some(item => res.id == item.id));
          //       alldata2.forEach(res => {
          //         res.type = 2; //2是修改
          //       });
          //       let deleteData2 = v2.list.filter(res => !alldata2.some(item => res.id == item.id));
          //       deleteData2.forEach(res => {
          //         res.type = 0; //0是删除
          //       });
          //       let addData2 = v.list.filter(res => !alldata2.some(item => res.id == item.id));
          //       arr1_1[k].list = [...alldata2, ...deleteData2, ...addData2];
          //     }
          //   });
          // });
          // this.formDate.foreign.pumpPrice = arr1_1;
          // // console.log(
          // //   JSON.parse(JSON.stringify(this.formDate.foreign.pumpPrice)),
          // //   "最终组装后"
          // // );
          // //泵送价格数据重组-结束
          // let type2 = false;
          // this.goodPriceArr.forEach(v => {
          //   if (!v.costId) {
          //     type2 = true;
          //   }
          // });
          // if (type2) {
          //   this.$message({
          //     message: "请检查表格数据是否完整！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // //产品价格数据重组-开始
          // let alldata02 = this.goodPriceArr.filter(res => this.formDate.foreign.goodPrice.some(item => res.id == item.id));
          // alldata02.forEach(res => {
          //   res.type = 2; //2是修改
          // });
          // let deleteData02 = this.formDate.foreign.goodPrice.filter(res => !alldata02.some(item => res.id == item.id));
          // deleteData02.forEach(res => {
          //   res.type = 0; //0是删除
          // });
          // let addData02 = this.goodPriceArr.filter(res => !alldata02.some(item => res.id == item.id));
          // this.formDate.foreign.goodPrice = [...alldata02, ...deleteData02, ...addData02];
          // //产品价格数据重组-结束
          // let type3 = false;
          // this.fuPriceArr.forEach(v => {
          //   if (!v.costId) {
          //     type3 = true;
          //   }
          // });
          // if (type3) {
          //   this.$message({
          //     message: "请检查表格数据是否完整！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // //附加收费项价格数据重组-开始
          // let alldata03 = this.fuPriceArr.filter(res => this.formDate.foreign.fuPrice.some(item => res.id == item.id));
          // alldata03.forEach(res => {
          //   res.type = 2; //2是修改
          // });
          // let deleteData03 = this.formDate.foreign.fuPrice.filter(res => !alldata03.some(item => res.id == item.id));
          // deleteData03.forEach(res => {
          //   res.type = 0; //0是删除
          // });
          // let addData03 = this.fuPriceArr.filter(res => !alldata03.some(item => res.id == item.id));
          // this.formDate.foreign.fuPrice = [...alldata03, ...deleteData03, ...addData03];
          // //附加收费项价格数据重组-结束
          this.formDate.cargoType = this.$fromatTable(this.cargoTypeIdArr, this.formDate.cargoTypeId, "id", "name");
          this.formDate.supplierName = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "name");
          this.formDate.supplierTypeId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "typeId");
          this.formDate.clearingSource = this.$fromatTable(this.theUnitPriceSource, this.formDate.clearingSourceId, "id", "itemName");
          this.formDate.clearingForm = this.$fromatTable(this.clearingFromIdList, this.formDate.clearingFormId, "id", "name");
          this.formDate.cooperationClass = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeName");
          this.formDate.cooperationClassId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeId");
          if (this.files.length != 0) {
            this.formDate.accessory = JSON.stringify(this.files);
          } else {
            this.$message.warning("请上传附件!");
            return;
          }
          // //站点数据重装-开始
          // if (this.formDate.stationsList?.length > 0) {
          //   let arr = [];
          //   this.formDate.stationsList.forEach(v => {
          //     this.sitelist.forEach(v2 => {
          //       if (v == v2.value) {
          //         arr.push({
          //           id: v,
          //           name: v2.label,
          //         });
          //       }
          //     });
          //   });
          //   this.formDate.stations = JSON.stringify(arr);
          // } else {
          //   this.formDate.stations = "";
          // }
          // //站点数据重装-结束
          // //业务点数据重组-开始
          // let arr = [];
          // if (this.formDate.business?.length > 0 || this.formDate.business != "[]") {
          //   this.formDate.business.forEach(v => {
          //     this.businessCheckbox.forEach(v2 => {
          //       if (v == v2.id) {
          //         arr.push({
          //           id: v,
          //           name: v2.itemName,
          //         });
          //       }
          //     });
          //   });
          //   this.formDate.business = JSON.stringify(arr);
          // } else {
          //   this.formDate.business = [];
          // }
          // this.formDate.accessory = JSON.stringify(this.files);
          if (Array.isArray(this.formDate.business) && !this.formDate.business.length) {
            this.formDate.business = null;
          }
          // //业务点数据重组-结束
          //工控拆分-开始
          if (this.formDate.contractContractType == 2 && (this.formDate.splitMode == 1 || this.formDate.splitMode == 2)) {
            let type4 = false;
            this.splitPriceArr.forEach(v => {
              if (!v.rawId || !v.supperId || !v.rawPrice || !v.files.length || (this.formDate.contractContractType == 2 && this.formDate.splitMode == 1 ? !v.mixProportion : false)) {
                type4 = true;
              }
            });
            if (type4) {
              this.$message({
                message: "请检查配合比表格数据是否完整！",
                type: "warning",
              });
              return;
            }
            let alldata04 = this.splitPriceArr.filter(res => this.formDate.foreign.splitPrice.some(item => res.id == item.id));
            alldata04.forEach(res => {
              res.type = 2; //2是修改
            });
            let deleteData04 = this.formDate.foreign.splitPrice.filter(res => !alldata04.some(item => res.id == item.id));
            deleteData04.forEach(res => {
              res.type = 0; //0是删除
            });
            let addData04 = this.splitPriceArr.filter(res => !alldata04.some(item => res.id == item.id));
            this.formDate.foreign.splitPrice = [...alldata04, ...deleteData04, ...addData04];
          } else {
            this.formDate.foreign.splitPrice = [];
          }
          //工控拆分-结束
          //工控拆分提交的数据文件转换为JSON-开始
          this.formDate.foreign.splitPrice.forEach(item => {
            item.attachFile = item.files.length > 0 ? JSON.stringify(item.files) : "";
          });
          //工控拆分提交的数据文件转换为JSON-结束
          //产品信息-开始
          if (this.formDate.strengthGradeArr?.length > 0) {
            // console.log(this.formDate.strengthGradeArr)
            this.formDate.strengthGrade = JSON.stringify(
              this.formDate.strengthGradeArr.map(v => {
                let obj = { id: v, name: this.strengthGradeList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          }
          if (this.formDate.performanceRequirementsArr?.length > 0) {
            this.formDate.performanceRequirements = JSON.stringify(
              this.formDate.performanceRequirementsArr.map(v => {
                let obj = { id: v, name: this.performanceGradeList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          } else {
            this.formDate.performanceRequirements = "";
          }
          if (this.formDate.materialRequirementsArr?.length > 0) {
            this.formDate.materialRequirements = JSON.stringify(
              this.formDate.materialRequirementsArr.map(v => {
                let obj = { id: v, name: this.meterialRequirementsList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          } else {
            this.formDate.materialRequirements = "";
          }
          if (this.formDate.specialRequirementsArr?.length > 0) {
            this.formDate.specialRequirements = JSON.stringify(
              this.formDate.specialRequirementsArr.map(v => {
                let obj = { id: v, name: this.specialRequirementsList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          } else {
            this.formDate.specialRequirements = "";
          }
          if (this.formDate.otherRequirementsArr?.length > 0) {
            this.formDate.otherRequirements = JSON.stringify(
              this.formDate.otherRequirementsArr.map(v => {
                let obj = { id: v, name: this.otherRequirementsList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          } else {
            this.formDate.otherRequirements = "";
          }
          if (this.formDate.additiveRequirementsArr?.length > 0) {
            this.formDate.additiveRequirements = JSON.stringify(
              this.formDate.additiveRequirementsArr.map(v => {
                let obj = { id: v, name: this.admixtureRequirementsList.find(v2 => v2.id == v)?.name };
                return obj;
              })
            );
          } else {
            this.formDate.additiveRequirements = "";
          }
          if (this.formDate.pouringMethodArr?.length > 0) {
            this.formDate.pouringMethod = JSON.stringify(
              this.formDate.pouringMethodArr.map(v => {
                let obj = { id: v, name: this.pumpTypeList.find(v2 => v2.id == v)?.itemName, type: this.pumpTypeList.find(v2 => v2.id == v)?.type };
                return obj;
              })
            );
          } else {
            this.formDate.pouringMethod = "";
          }
          //产品信息-结束
          //协外站点
          let type5 = false;
          if (this.otherStationArr.length == 0) {
            this.$message.warning("协外站点不能为空!");
            return;
          }
          this.otherStationArr.forEach(v => {
            if (!v.id) {
              type5 = true;
            }
          });
          if (type5) {
            this.$message({
              message: "请检查协外站点表格数据是否完整！",
              type: "warning",
            });
            return;
          }
          this.formDate.stations = JSON.stringify(this.otherStationArr);
          //特殊运载
          let type6 = false;
          console.log(this.specialTransport)
          if (this.specialTransport.length == 0) {
            console.log('----------------------------')
            this.formDate.specialTransport = "";
          } else {
            this.specialTransport.forEach(v => {
              if (!v.pumpId || !v.price) {
                type6 = true;
              }
            });
            if (type6) {
              this.$message({
                message: "请检查特殊运载表格数据是否完整！",
                type: "warning",
              });
              return;
            }
            this.formDate.specialTransport = JSON.stringify(this.specialTransport);
          }
          contractSaveOrUpdate(this.formDate).then(res => {
            if (res.code == 1001) {
              this.addDialog = false;
              this.$message.success("操作成功");
              this.init();
            }
          });
        } else {
          this.$message({
            message: "必填字段填写不完全！",
            type: "warning",
          });
          return false;
        }
      });
    },
    //获取合同详情
    contractQueryDetailByIdFun(d) {
      // if (this.$refs.reffromDate) {
      //   this.$refs.reffromDate.resetFields();
      // }
      this.addDialog = true;
      this.modifyType = true;
      this.pumpPriceArr = [];
      contractQueryDetailById({ id: d }).then(async res => {
        // this.formDate = res.data.contract;
        this.formDate = { ...this.formDate, ...res.data.contract };
        this.changemainCompanyId(this.formDate.supplierId, true);
        this.formDate.startDayendDay = [];
        this.formDate.startDayendDay[0] = this.formDate.startDay;
        this.formDate.startDayendDay[1] = this.formDate.endDay;
        // this.formDate.foreign = {};
        // this.formDate.foreign.yunPrice = this.copy(res.data.list.yunPrice);
        // this.yunPriceArr = this.copy(res.data.list.yunPrice);
        // this.formDate.foreign.pumpPrice = this.copy(res.data.list.pumpPrice);
        // this.pumpPriceArr = this.copy(res.data.list.pumpPrice);
        // this.formDate.foreign.goodPrice = this.copy(res.data.list.goodPrice);
        // this.goodPriceArr = this.copy(res.data.list.goodPrice);
        // this.formDate.foreign.fuPrice = this.copy(res.data.list.fuPrice);
        // this.fuPriceArr = this.copy(res.data.list.fuPrice);
        console.log(this.formDate);
        if (this.formDate.strengthGrade) {
          this.formDate.strengthGradeArr = JSON.parse(this.formDate.strengthGrade)?.map(v => v.id); //强度等级
        }
        // console.log(this.strengthGradece)
        if (this.formDate.performanceRequirements) {
          this.formDate.performanceRequirementsArr = JSON.parse(this.formDate.performanceRequirements)?.map(v => v.id); //性能等级
        }
        if (this.formDate.materialRequirements) {
          this.formDate.materialRequirementsArr = JSON.parse(this.formDate.materialRequirements)?.map(v => v.id); //材料要求
        }
        if (this.formDate.specialRequirements) {
          this.formDate.specialRequirementsArr = JSON.parse(this.formDate.specialRequirements)?.map(v => v.id); //特殊要求
        }
        if (this.formDate.otherRequirements) {
          this.formDate.otherRequirementsArr = JSON.parse(this.formDate.otherRequirements)?.map(v => v.id); //其他要求
        }
        if (this.formDate.additiveRequirements) {
          this.formDate.additiveRequirementsArr = JSON.parse(this.formDate.additiveRequirements)?.map(v => v.id); //外加剂要求
        }
        if (this.formDate.pouringMethod) {
          const pouringMethod = JSON.parse(this.formDate.pouringMethod);
          const arr = [];
          for (let i = 0; i < this.pumpTypeList.length; i++) {
            for (let j = 0; j < pouringMethod.length; j++) {
              if (pouringMethod[j].id === this.pumpTypeList[i].id) {
                arr.push(pouringMethod[j].id);
              }
            }
          }
          this.formDate.pouringMethodArr = arr;
          // this.formDate.pumpTypeArr = JSON.parse(this.formDate.pumpType) ?.map((v) => v.id)//泵送方式
        }
        res.data.list.splitPrice.forEach(item => {
          item["files"] = item.attachFile ? JSON.parse(item.attachFile) : [];
        });
        this.splitPriceArr = this.copy(res.data.list.splitPrice);
        this.formDate.foreign.splitPrice = this.copy(res.data.list.splitPrice);
        this.otherStationArr = JSON.parse(this.formDate.stations) || [];
        this.specialTransport = JSON.parse(this.formDate.specialTransport) || [];
        this.files = JSON.parse(this.formDate.accessory) || [];
        let stationArr = JSON.parse(this.formDate.stations) || [];
        this.formDate.stationsList = stationArr.map(item => {
          return item.id;
        });
        // if (this.formDate.business) {
        //   let arr2 = [];
        //   JSON.parse(this.formDate.business).forEach(v => {
        //     arr2.push(v.id);
        //   });
        //   this.formDate.business = arr2;
        // } else {
        //   this.formDate.business = [];
        // }
        // await this.companylistChangeFun(false, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
        if (this.formDate.accessory != null) {
          this.formDate.accessory = JSON.parse(this.formDate.accessory);
        } else {
          this.formDate.accessory = [];
        }
        //判断公司-站点权限是否包含返回的详情id值，在就回显，不在就回显提示信息placeholder
        // let type1 = this.companylist.findIndex(res => res.value == this.formDate.firstPartyId);
        // if (type1 == -1) {
        //   this.formDate.firstPartyId = "";
        //   this.formDate.firstPartyIdPlaceholder = this.formDate.firstParty;
        //   let text = "";
        //   JSON.parse(this.formDate.stations).forEach(v => {
        //     text = text + v.name + " ";
        //   });
        //   this.formDate.stations = "";
        //   this.formDate.stationsList = [];
        //   this.formDate.stationsPlaceholder = text;
        // } else {
        //   if (this.formDate.stations) {
        //     let arr1 = [];
        //     JSON.parse(this.formDate.stations).forEach(v => {
        //       arr1.push(v.id);
        //     });
        //     this.formDate.stationsList = arr1;
        //   } else {
        //     this.formDate.stationsList = [];
        //   }
        // }
        // await this.stationsControlPointFun(true); //获取已选择站点名称的业务点
        this.$forceUpdate();
        console.log(JSON.parse(JSON.stringify(this.formDate)));
      });
    },
    //调价列表
    riseInPriceQueryOneByidFun(d) {
      console.log(d);
      this.low2 = d;
      this.dialog2 = true;
      // this.contractId = d.id;
      // this.riseInPriceQueryOneByidType = true;
      // contractQueryDetailById({ id: d.id }).then(async res => {
      //   this.formDate = res.data.contract;
      //   await this.companylistChangeFun(true, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
      //   this.yunPriceArr = this.copy(res.data.list.yunPrice);
      //   this.pumpPriceArr = this.copy(res.data.list.pumpPrice);
      //   this.goodPriceArr = this.copy(res.data.list.goodPrice);
      //   this.fuPriceArr = this.copy(res.data.list.fuPrice);
      // });
    },
    //价格设置-调价详情-列表
    QueryOneByidFun(d, moneyType) {
      this.QueryOneByidType = true;
      this.modifyType = false;
      this.QueryOneByidArr = [];
      this.contractRawMoneySaveForm.startTime = "";
      this.QueryOneByidObject.contractId = this.contractId;
      if (d) {
        this.QueryOneByidObject.rawId = d.id;
        this.moneyType = moneyType;
      }
      if (this.moneyType) {
        this.QueryOneByidObject.contractFacility = this.QueryOneByidObject.rawId;
        PumpPriceLogQueryPage(this.QueryOneByidObject).then(res => {
          this.QueryOneByidArr = res.data;
        });
        this.carTwosArr = d.list;
        console.log(JSON.parse(JSON.stringify(d)));
        // if (d.id == 1) {
        this.carTwosArr = [];
        this.yunPriceArr.forEach((v, k) => {
          let json = {
            minDistance: k == 0 ? 0 : this.yunPriceArr[k - 1].costName,
            maxDistance: v.costName,
            price: v.costUnit, //价格
            addDistance: v.costDetail, //每增加距离
          };
          this.carTwosArr.push(json);
        });
        // }
      } else {
        QueryOneByid(this.QueryOneByidObject).then(res => {
          this.QueryOneByidArr = res.data.data;
          this.QueryOneByidObject.total = res.data.totalRows;
        });
      }
    },
    basePriceListFun2(d) {
      this.basePriceListType2 = true;
      let obj = {
        contractId: d.contractId,
        contractFacility: d.contractFacility,
        startTime: d.startTime,
      };
      PumpPriceLogGetDetail(obj).then(res => {
        if (res.code == 1001) {
          this.carTwosArr2 = res.data;
        }
      });
    },
    //价格设置，提交
    contractRawMoneySaveFun() {
      if (!this.files2?.length) {
        return this.$message.warning("请上传附件文件");
      }
      this.$refs.contractRawMoneySaveForm.validate(valid => {
        if (valid) {
          this.contractRawMoneySaveForm.contractId = this.contractId;
          this.contractRawMoneySaveForm.rawId = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.contractFacility = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.filePaths = JSON.stringify(this.files2);
          if (this.moneyType) {
            /**判断区间范围是否正确--开始 */
            let type1 = false;
            let arr1 = this.carTwosArr;
            arr1.forEach((v, k) => {
              if (k > 0 && v.minDistance - arr1[k - 1].minDistance <= 0) {
                type1 = true;
              }
            });
            console.log(JSON.parse(JSON.stringify(arr1)), type1);
            /**判断区间范围是否正确--结束 */
            if (type1) {
              this.$message({
                message: "区间值范围不正确，请检查！",
                type: "warning",
              });
            } else {
              this.contractRawMoneySaveForm.list = this.carTwosArr;
              //泵车价格区间的
              PumpPriceLogSave(this.contractRawMoneySaveForm).then(res => {
                if (res.code == 1001) {
                  this.QueryOneByidFun();
                }
              });
            }
          } else {
            contractRawMoneySave(this.contractRawMoneySaveForm).then(res => {
              if (res.code == 1001) {
                this.QueryOneByidFun();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //删除价格
    contractRawMoneyDeletesFun(d) {
      if (this.moneyType) {
        //泵车价格区间的
        let obj = {
          contractId: this.contractId,
          contractFacility: d.contractFacility,
          startTime: d.startTime,
        };
        PumpPriceLogDeletes(obj).then(() => {
          this.QueryOneByidFun();
        });
      } else {
        contractRawMoneyDeletes({ id: d.id }).then(() => {
          this.QueryOneByidObject.page = 1;
          this.QueryOneByidFun();
        });
      }
    },
    //协作单位组合
    queryListsByPidFun(d) {
      this.contractId = d.id;
      this.AllqueryListsByPid = true;
      console.log(d);
      queryListsByPid({ supplierId: d.supplierId }).then(res => {
        this.queryListsByPidArr = res.data;
        // let obj = {
        //   id: d.supplierId,
        //   name: d.supplierName,
        // };
        // this.queryListsByPidArr.splice(0, 0, obj);
      });
    },
    //开户信息详情
    contractAccountGetDetailFun(d) {
      this.contractAccountSaveForm = {};
      this.contractAccountGetDetailType = true;
      let obj = {
        contractId: d.id,
        pid: d.supplierId,
        type: 1,
      };
      contractAccountGetDetail(obj).then(res => {
        this.contractAccountSaveForm = res.data;
        this.$refs.contractAccountSaveForm.resetFields();
      });
    },
    //开户信息保存
    contractAccountSaveFun() {
      this.$refs.contractAccountSaveForm.validate(valid => {
        if (valid) {
          // this.formDate.contractPact = this.$fromatTable(
          //   this.contractPactIdArr,//未知
          //   this.formDate.contractPactId,
          //   "id",
          //   "name"
          // );
          contractAccountSave(this.contractAccountSaveForm).then(res => {
            if (res.code == 1001) {
              this.contractAccountGetDetailType = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //重置表格-渲染
    reset() {
      this.modifyType = false;
      this.formDate = {
        startDayendDay: [],
        id: "",
        contractTypeId: "6",
        contractType: "协外",
        contractContractType: "", //合同的合同类型
        splitMode: "", //拆分方式
        pumpCompensation: "", //泵送方
        pumpCompensationPrice: "", //泵送价格
        transportCompensation: "", //运输方
        transportCompensationPrice: "", //运输价格
        strengthGrade: "", //强度等级
        strengthGradeArr: [], //强度等级
        performanceRequirements: "", //性能等级
        performanceRequirementsArr: [], //性能等级
        materialRequirements: "", //材料要求
        materialRequirementsArr: [], //材料要求
        specialRequirements: "", //特殊要求
        specialRequirementsArr: [], //特殊要求
        otherRequirements: "", //其他要求
        otherRequirementsArr: [], //其他要求
        additiveRequirements: "", //外加剂要求
        additiveRequirementsArr: [], //外加剂要求
        pouringMethod: "", //泵送方式
        pouringMethodArr: [], //泵送方式
        firstParty: "", //甲方
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        periodType: "", //结算周期类型
        periodDay: "", //结算周期
        adjustMethod: 1, //补充协议
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        business: [], //业务点1，2，3
        foreign: {
          yunPrice: [], //价格区间
          pumpPrice: [], //泵送价格
          goodPrice: [], //强度等级价格
          fuPrice: [], //附加收费项价格
          splitPrice: [],
        },
        taxRate: "", //税率
      };
      this.yunPriceArr = []; //价格区间
      this.pumpPriceArr = []; //泵送价格
      this.goodPriceArr = []; //强度等级价格
      this.fuPriceArr = []; //附加收费项价格
      this.otherStationArr = []; //协外站点
      this.specialTransport = []; //特殊运载
      this.splitPriceArr = []; //工控拆分
      this.businessCheckbox = [];
      this.yunPriceArr = [
        {
          id: "",
          costName: 1, //距离
          costUnit: 0, //价格
          type: 1, //1新增；2修改 0删除
        },
        {
          id: "",
          costName: 2, //距离
          costUnit: 0, //价格
          type: 1, //1新增；2修改 0删除
        },
        {
          id: "",
          costName: 9999999, //距离
          costUnit: 0, //价格
          costDetail: 0, //每增加
          type: 1, //1新增；2修改 0删除
        },
      ];
      this.files = [];
      this.checked1 = false;
      this.checked2 = false;
      this.checked3 = false;
      this.checked4 = false;
      this.checked5 = false;
      this.checked6 = false;
      this.checked7 = false;
    },
    //重置表格-渲染
    resetCarTwos() {
      this.formDate.foreign.yunPrice = [
        {
          id: "",
          costName: 1, //距离
          costUnit: 0, //价格
          type: 1, //1新增；2修改 0删除
        },
        {
          id: "",
          costName: 2, //距离
          costUnit: 0, //价格
          type: 1, //1新增；2修改 0删除
        },
        {
          id: "",
          costName: 9999999, //距离
          costUnit: 0, //价格
          type: 1, //1新增；2修改 0删除
        },
      ];
      this.$forceUpdate();
    },
    //重置表格-渲染
    resetPumpPrice() {
      this.formDate.foreign.pumpPrice = [];
    },
    //站点选择后重置
    stationsTypeFun() {
      this.formDate.business = [];
    },
    //泵列表选择后赋值泵类型
    pumpTypeId_pumpTypeFun(e, k, name) {
      if (name == "泵车类型") {
        let type = false;
        this.pumpPriceArr.findIndex((v, index) => {
          if (v.costId == e.costId && k != index) {
            type = true;
          }
        });
        if (type) {
          this.$message({
            message: "该泵车类型已存在！",
            type: "warning",
          });
          e.costId = "";
          return;
        }
        this.pumpPriceArr[k].costName = this.$fromatTable(this.pumpTypeArr, e.costId, "id", "itemName");
      } else if (name == "强度等级") {
        let type = false;
        this.goodPriceArr.findIndex((v, index) => {
          if (v.costId == e.costId && k != index) {
            type = true;
          }
        });
        if (type) {
          this.$message({
            message: "该强度等级已存在！",
            type: "warning",
          });
          e.costId = "";
          return;
        }
        this.goodPriceArr[k].costName = this.$fromatTable(this.goodPriceList, e.costId, "id", "name");
      } else if (name == "附加收费项") {
        let type = false;
        this.fuPriceArr.findIndex((v, index) => {
          if (v.costId == e.costId && k != index) {
            type = true;
          }
        });
        if (type) {
          this.$message({
            message: "该附加收费项已存在！",
            type: "warning",
          });
          e.costId = "";
          return;
        }
        this.fuPriceArr[k].costName = this.$fromatTable(this.fuPriceList, e.costId, "ID", "NAME");
      }
    },
    //泵列表添加一条数据
    addItemPumpList(name) {
      let obj = {
        id: "",
        costName: "", //名称
        costId: "", //名称id
        costUnit: 0, //价格
        type: 1,
      };
      if (name == "泵车类型") {
        let data = {
          id: "",
          deviceName: "", //设备名称
          deviceId: "", //设备id
          basePrice: 0, //单价
          assessmentPrice: 0, //考核价
          type: 1,
          list: [
            {
              id: "",
              distance: 1, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 2, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
            {
              id: "",
              distance: 9999999, //距离
              price: 0, //价格
              addDistance: 0, //每增加距离
              type: 1, //1新增，2修改，0删除
            },
          ],
        };
        this.pumpPriceArr.push(data);
      } else if (name == "强度等级") {
        obj.costDetail = 0;
        obj.costUnit = 0;
        this.goodPriceArr.push(obj);
      } else if (name == "附加收费项") {
        obj.costDetail = 0;
        obj.costUnit = 0;
        this.fuPriceArr.push(obj);
      } else if (name == "协外站点") {
        let data = {
          name: "",
          id: "",
        };
        this.otherStationArr.push(data);
      } else if (name == "特殊运载") {
        let data = {
          pumpId: "",
          pumName: "",
          price: "",
        };
        this.specialTransport.push(data);
      } else if (name == "工控拆分") {
        let data = {
          id: "",
          type: 1,
          rawMaterialName: "",
          rawMaterialContractId: "",
          contractCode: "",
          rawMaterialId: "",
          supperId: "",
          supperName: "",
          mixProportion: "",
          specification: "",
          specificationId: "",
          rawId: "",
          rawPrice: "",
          attachFile: "",
          files: [],
        };
        this.splitPriceArr.push(data);
      }
      this.$forceUpdate();
    },
    deleteItemPumpList(index, name) {
      if (name == "泵车类型") {
        this.pumpPriceArr.splice(index, 1);
      } else if (name == "强度等级") {
        this.goodPriceArr.splice(index, 1);
      } else if (name == "附加收费项") {
        this.fuPriceArr.splice(index, 1);
      } else if (name == "协外站点") {
        this.otherStationArr.splice(index, 1);
      } else if (name == "特殊运载") {
        this.specialTransport.splice(index, 1);
      } else if (name == "工控拆分") {
        this.splitPriceArr.splice(index, 1);
      }
    },
    /**合同编号是否重复 */
    queryContractNumberFun() {
      queryContractNumber({ contractNumber: this.formDate.contractNumber, id: this.formDate.id }).then(res => {
        if (res.code == 1001 && !res.data) {
          this.$message({
            message: "合同编号重复！",
            type: "warning",
          });
          this.formDate.contractNumber = "";
        }
      });
    },
    handleAvatarSuccess1(res) {
      if (res.code === 1001) {
        console.log(res.data);
        this.appPackage = [];
        this.formDate.appPackage = res.data.fileName;
        this.formDate.accessory = res.data.fileUrl;
      }
    },
    beforeAvatarUpload1(file) {
      console.log(file);
    },
    /**区间填入值不能小于等于前一个大于等于后一个 */
    inpuSizeCheck(val, k, arr) {
      console.log(val, k);
      if (arr.length == k + 2 && k > 0) {
        arr[k + 1].costName = val;
      }
      let frontNumber = "",
        afterNumber = "";
      let l = k - 1;
      if (k < 0) {
        frontNumber = 0;
      } else {
        for (l; l >= 0; l--) {
          frontNumber = arr[l].costName;
          break;
        }
      }
      let i = k + 1;
      for (i; i < arr.length; i++) {
        afterNumber = arr[i].costName;
        break;
      }
      console.log(JSON.parse(JSON.stringify(arr)));
      console.log(val, frontNumber, afterNumber);
      if (val - frontNumber <= 0) {
        console.log(val + ":" + frontNumber);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else if (arr.length != k + 2 && afterNumber - val <= 0) {
        console.log(afterNumber + ":" + val);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      }
    },
    /**区间填入值不能小于等于前一个大于等于后一个 */
    inpuSizeCheck2(val, k, arr) {
      let frontNumber = "",
        afterNumber = "";
      let l = k - 1;
      for (l; l >= 0; l--) {
        frontNumber = arr[l].distance;
        break;
      }
      let i = k + 1;
      if (i == arr.length) {
        afterNumber = 9999999;
      } else {
        for (i; i < arr.length; i++) {
          afterNumber = arr[i].distance;
          break;
        }
      }
      if (val - frontNumber <= 0) {
        console.log(val + ":" + frontNumber);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else if (afterNumber - val <= 0) {
        console.log(afterNumber + ":" + val);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      }
    },
    /**区间填入值不能小于等于前一个大于等于后一个 */
    inpuSizeCheck3(val, k, arr) {
      let frontNumber = "",
        afterNumber = "";
      let l = k - 1;
      for (l; l >= 0; l--) {
        frontNumber = arr[l].minDistance;
        break;
      }
      let i = k + 1;
      if (i == arr.length) {
        afterNumber = 9999999;
      } else {
        for (i; i < arr.length; i++) {
          afterNumber = arr[i].minDistance;
          break;
        }
      }
      if (val - frontNumber <= 0) {
        console.log(val + ":" + frontNumber);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      } else if (afterNumber - val <= 0) {
        console.log(afterNumber + ":" + val);
        this.$message({
          message: "区间值范围不正确，请检查！",
          type: "warning",
        });
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    //价格设置，是否显示价格输入框，对应价格区间显示
    moneyFun(moneyType) {
      if (moneyType) {
        return true;
      } else {
        return false;
      }
    },
    //站点list表格中拼接展示
    stationsFun(arr) {
      if (arr) {
        let ket = JSON.parse(arr).map(res => {
          return res.name;
        });
        return ket.join("、");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  .el-input,
  .el-select {
    width: 230px;
  }
}
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
.FZYguanKongYeWuDian {
  display: flex;
  > table {
    flex: none;
    width: 100px;
  }
  > div {
    flex: 1;
  }
}
.FZY1-3 {
  border-bottom: 1px solid #f2f2f2;
  .liBox1,
  .liBox2 {
    padding: 10px;
    width: 520px;
    display: flex;
    > div:nth-of-type(1) {
      width: 210px;
    }
    > div:nth-of-type(2) {
      flex: 1;
    }
    span {
      display: inline-block;
      margin-left: 20px;
    }
    .el-input-number ::v-deep {
      margin-left: 20px;
    }
  }
  .liBox3 {
    padding: 10px;
    width: 650px;
    display: flex;
    > div:nth-of-type(1) {
      display: flex;
      > div:nth-of-type(1) {
        width: 210px;
        span {
          margin-left: 10px;
        }
        .el-input-number ::v-deep {
          margin-left: 10px;
          width: 80px;
        }
      }
      span {
        display: inline-block;
        margin-left: 20px;
      }
      .el-input-number ::v-deep {
        margin-left: 20px;
      }
    }
    > div:nth-of-type(2) {
      width: 130px;
      flex: none;
      line-height: 28px;
      padding-left: 20px;
    }
  }
}
</style>
<style lang="scss">
.outsourcing {
  // .FZYcheckbox {
  //   .el-checkbox {
  //     min-width: 155px;
  //     margin-right: 0px;
  //   }
  // }
  .FZYform {
    padding-top: 0px !important;
    // .el-form-item {
    //   min-width: 445px;
    //   .el-input,
    //   .el-select {
    //     width: 340px;
    //   }

    // }
    .zq {
      // min-width: 500px;

      .el-input {
        width: 100px !important;
      }

      .el-input-number.is-without-controls .el-input__inner {
        width: 50px !important;
      }
    }

    .hyyc {
      width: 340px;

      .el-input {
        width: 340px;
      }
    }
  }
  .FZYform2 {
    .el-form-item__error {
      white-space: nowrap;
    }
  }
  .FZYselectList {
    .el-select {
      width: 85px !important;
      margin-right: 10px;
    }
  }
}
</style>
<style scoped>
.periodType >>> .el-select {
  width: 100px !important;
}
.periodType >>> .el-input {
  width: 100px !important;
}
</style>